<template>
    <b-button 
        v-if="permiteDevolver"
        class="ml-2"
        variant="danger"
        @click.stop="confirmarDevolver()"
    >
        <span>
            <i class="fa fa-reply-all"></i>
            Devolver
        </span>
    </b-button>
</template>

<script>
import { StatusDespesa } from './StatusDespesa';

export default {
    props: {
        despesa: {
            type: Object
        },

        servicos: { 
            type: Object
        },

        permiteAcessoPorPerfil: {
            type: Boolean,
            default: () => false
        }
    },

    methods: {
        confirmarDevolver() {
            this.$swal({
                title: 'Despesa',
                html: `Confirma o cancelamento da aprovação da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.devolver()
                }
            })
        },

        devolver() {
            this.$store.dispatch('addRequest')
            this.servicos.devolver(this.despesa.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa devolvida com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterDespesa')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        permiteDevolver() {
            return this.permiteAcessoPorRota
                && this.permiteAcessoPorPerfil
                && this.despesa != null    
                && ( this.despesa.statusId == StatusDespesa.AGUARDANDO_APROVACAO_DEMANDANTE
                    || this.despesa.statusId == StatusDespesa.AGUARDANDO_APROVACAO_GERENTE )
        },

        permiteAcessoPorRota() {
            return this.$route.name == 'DespesasGerais_Requisitantes_Despesas_Detalhar'
                || this.$route.name == 'DespesasGerais_Fornecedores_Despesas_Detalhar'
        },
    }
}


</script>